import React, { useState } from 'react';
import PasswordChecklist from 'react-password-checklist';
import { EyeIcon, EyeOffIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Card } from '@/shared/ui/card';
import { Label } from '@/shared/ui/label';
import { Input } from '@/shared/ui/input';

const INPUT_CLASS = 'text-[#868C98] font-normal';

export function PasswordField({ value, onChange, onValidityChange }) {
  const { t } = useTranslation();
  const [showPassword, setShowPassword] = useState(false);
  const [focused, setFocused] = useState(false);

  return (
    <div className="flex flex-col space-y-1.5">
      <Label htmlFor="password" className="font-semibold">
        {t('common.password')}
      </Label>
      <div className="relative">
        <Input
          required
          id="password"
          name="password"
          value={value}
          onChange={onChange}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          placeholder={t('auth.enterPassword')}
          type={showPassword ? 'text' : 'password'}
          autoComplete="new-password"
          className={INPUT_CLASS}
        />
        <button
          type="button"
          onClick={() => setShowPassword((v) => !v)}
          className="absolute inset-y-0 right-3 flex items-center focus:outline-none"
          aria-label={showPassword ? 'Hide password' : 'Show password'}
        >
          {showPassword ? (
            <EyeOffIcon size={15} strokeWidth={2.5} />
          ) : (
            <EyeIcon size={15} strokeWidth={2.5} />
          )}
        </button>
        {focused && (
          <Card className="absolute top-full mt-[6px] w-full py-2 px-3 rounded-xl z-50">
            <PasswordChecklist
              className="text-sm font-normal"
              rules={['minLength', 'specialChar', 'number', 'capital']}
              minLength={8}
              value={value}
              iconSize={11}
              invalidColor="#71717a"
              invalidTextColor="#71717a"
              onChange={onValidityChange}
            />
          </Card>
        )}
      </div>
    </div>
  );
}
